import services from 'services'

export default {

  get(token) {
    return services.fetch(`/v1/application/${token}`)
  },

  create(application) {
    return services.fetch(
      '/v1/application',
      {
        method: 'POST',
        body: application,
      },
    )
  },

  update(application, continueLater) {
    return services.fetch(
      `/v1/application/${application._id}`,
      {
        method: 'PATCH',
        body: { ...application, continueLater },
      },
    )
  },

  putVideoResponse(applicationId, videoResponse) {
    return services.fetch(
      `/v1/application/${applicationId}/response`,
      {
        method: 'PUT',
        body: videoResponse,
      },
    )
  },

  putMobileVideoResponse(applicationId, videoResponse) {
    return services.fetch(
      `/v1/application/${applicationId}/mobile-response`,
      {
        method: 'PUT',
        body: videoResponse,
      },
    )
  },

  deleteVideoResponse(applicationId, videoResponse) {
    return services.fetch(
      `/v1/application/${applicationId}/response`,
      {
        method: 'DELETE',
        body: videoResponse,
      },
    )
  },

  fetchOpentokSessionData(applicationId) {
    return services.fetch(`/v1/application/${applicationId}/opentokSession`)
  },
}
